// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1e022780","239":"e375640c","455":"f3befb00"}[chunkId] + ".chunk.js";
};